import { useEffect, useState } from 'react';
import { KhachHang, PhieuXuatKho, QuyenChungTu } from '@/types/schemas';

export interface FormFieldState {
  customer: KhachHang | null;
  quyenChungTu: QuyenChungTu | null;
  soChungTu: string;
}

export interface FormFieldActions {
  setCustomer: (customer: KhachHang) => void;
  setQuyenChungTu: (quyenChungTu: QuyenChungTu) => void;
  setSoChungTu: (soChungTu: string) => void;

  resetState: () => void;
  updateState: (updates: Partial<FormFieldState>) => void;
}

export interface UseFormFieldStateReturn {
  state: FormFieldState;
  actions: FormFieldActions;
}

const initialState: FormFieldState = {
  customer: null,
  quyenChungTu: null,
  soChungTu: ''
};

function transformInitialData(initialData?: PhieuXuatKho | null): Partial<FormFieldState> {
  if (!initialData) return {};

  return {
    customer: initialData.ma_kh_data || null,
    quyenChungTu: initialData.ma_nk_data || null,
    soChungTu: initialData.so_ct || ''
  };
}

export function useFormFieldState(initialData?: PhieuXuatKho | null): UseFormFieldStateReturn {
  const [state, setState] = useState<FormFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  // Update state when initialData changes
  useEffect(() => {
    if (initialData) {
      setState(prev => ({
        ...prev,
        ...transformInitialData(initialData)
      }));
    }
  }, [initialData]);

  const actions: FormFieldActions = {
    setCustomer: (customer: KhachHang) => {
      setState(prev => ({
        ...prev,
        customer
      }));
    },

    setQuyenChungTu: (quyenChungTu: QuyenChungTu) => {
      setState(prev => ({
        ...prev,
        quyenChungTu
      }));
    },

    setSoChungTu: (soChungTu: string) => {
      setState(prev => ({
        ...prev,
        soChungTu
      }));
    },

    resetState: () => {
      setState(initialState);
    },

    updateState: (updates: Partial<FormFieldState>) => {
      setState(prev => ({ ...prev, ...updates }));
    }
  };

  return { state, actions };
}
